import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">热门视频</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">高清吃瓜视频 · 精彩不容错过</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <article key={item.id} className="bg-background-50 rounded-lg overflow-hidden border border-background-200 group cursor-pointer hover:border-primary-200 transition-colors">
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-lg md:text-xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/70 text-background-50 text-[10px] font-medium whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}